// extracted by mini-css-extract-plugin
module.exports = {"cart-items":"Cart_cart-items__1fgTI","total":"Cart_total__3jsNT","actions":"Cart_actions__3IG7l","button--alt":"Cart_button--alt__2jnCF","button":"Cart_button__lvG-4"};